export default "__VITE_ASSET__CTK7sy7E__"